import { Create } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { Inspection } from "inspector-common/lib/model";
import { useNavigate } from "react-router-dom";

interface InspectionListItemProps {
    inspection: Inspection
};

const styles = {
    box: {
        display: "block",
    }
}

export default function InspectionListItem(props: InspectionListItemProps) {
    const navigate = useNavigate();

    return <Box>
        <Button 
            variant="text" 
            onClick={() => navigate("/assignments/edit/" + props.inspection.assignment_id + "/inspections/" + props.inspection.identifier)}
            startIcon={<Create />}
        >
            <Typography>{props.inspection.name}</Typography>
        </Button>
    </Box>
}